import NumberFormattedField from './NumberFormattedField';

export default NumberFormattedField;
